// src/pages/tournament/HistoryPanel.jsx
// Who changed which score and when, and what it was before. Read-only: a wrong score is corrected in the round itself.
import React, { useEffect, useState } from 'react';
import { apiRequest } from '../../api';
import { formatExact, formatWhen } from '../../utils/time';

const place = (entry) => `Round ${entry.round}, court ${entry.court}, match ${entry.match}, set ${entry.set}`;

function HistoryPanel({ tournamentId, userId, standalone = false }) {
    const [open, setOpen] = useState(standalone); // (in its own view it is simply open)
    const [entries, setEntries] = useState(null); // null: not loaded
    const base = `/tournaments/${tournamentId}`;

    const load = async () => {
        try {
            setEntries(await apiRequest('GET', `${base}/history`, userId));
        } catch (error) {
            // Nothing to show is a fine answer: an empty history, not an alarm (the history is only a convenience).
            console.error('Error loading the score history:', error);
            setEntries([]);
        }
    };

    useEffect(() => {
        if (standalone) load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [standalone, tournamentId, userId]);

    const toggle = () => {
        const next = !open;
        setOpen(next);
        if (next) load();
    };

    return (
        <section className="card history-card" aria-label="Score history">
            {standalone ? (
                <h2>Score history</h2>
            ) : (
                <button className="section-toggle" aria-expanded={open} onClick={toggle}>
                    <h2>Score history</h2>
                </button>
            )}
            {open && (
                <div className="history-body">
                    <p className="hint">The latest changes of scores in this tournament: who, when, and what it was before.</p>
                    {entries === null ? (
                        <div className="skeleton" aria-busy="true" />
                    ) : entries.length === 0 ? (
                        <p className="hint">No score has been changed yet.</p>
                    ) : (
                        <ul className="history-list">
                            {entries.map((entry) => (
                                <li key={`${entry.at}-${entry.roundId}-${entry.matchupId}-${entry.matchId}-${entry.setId}`}>
                                    <div className="history-score">
                                        <strong>
                                            {entry.before[0]}–{entry.before[1]} → {entry.after[0]}–{entry.after[1]}
                                        </strong>
                                        <span className="muted" title={formatExact(entry.at)}>
                                            {formatWhen(entry.at)}
                                        </span>
                                    </div>
                                    {entry.team1 && entry.team2 && (
                                        <div className="history-teams">
                                            {entry.team1.join(' & ')} <span className="muted">vs</span> {entry.team2.join(' & ')}
                                        </div>
                                    )}
                                    <div className="history-where muted">
                                        {place(entry)} · {entry.by}
                                    </div>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            )}
        </section>
    );
}

export default HistoryPanel;
